<template>
  <div id="MWarehouseSetting" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">A</span>lmacenes</div>
        <div class="col-3 t-r f22 pr3"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" v-for="(warehouse,warehouse_i) in data_list" v-bind:key="warehouse_i" @click="select_on(warehouse_i)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-2 pt10">
                <img src="@/assets/warehouse.png"  class="w5"> 
              </div>
              <div class="col-8 pl10 pt8">
                <div class="col-12 f14 uppercase">{{ warehouse.enterprise_name }} <span v-if="warehouse.store > 1">[{{ warehouse.store }}]</span></div>
                <div class="col-12 f14 fw uppercase pb2 el1">{{ warehouse.warehouse_name }}</div>
              </div>
              <div class="col-2 color-muted t-r lh50 pr5">
                <i class="iconfont icon-checkbox-xuanzhong f22 color-primary" v-if="warehouse.warehouse == 1"></i>
                <i class="iconfont icon-checkbox-weixuan f22 color-muted" v-else></i>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MWarehouseSetting',
  data () {
    return {
      data_list: [],
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      this.post(this.api_url + 'manage/m_warehouse_list', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data;
        }else{
          this.data_list = []
        }
      })
    },
    //选择仓库
    select_on(warehouse_i) {
      var post_data = {};
      post_data.appid = this.data_list[warehouse_i].appid;
      this.post(this.api_url + 'manage/m_warehouse_select', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.get_list_data();
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/MWarehouseSetting.vue